import { createFileRoute } from '@tanstack/react-router'
import IntegrationsSettings from '@/pages/settings/integrations'

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/settings/integrations'
)({
  component: IntegrationsSettings,
})
